import store from '@/store';

/**
 * Config de axios con el token de la sesión en `Authorization`.
 *
 * Por pedido y no con un interceptor global: un interceptor registrado al
 * importar un módulo (como hace convalidaciones) cambia TODAS las llamadas de
 * la app según qué pantalla se abrió primero. Acá cada capa de API decide qué
 * endpoints lo mandan.
 *
 * El token lo guarda el login (POST /signin) en la sesión del store.
 */
export function conToken(config = {}) {
  const user = store.getters.user;
  const token = user && user.token;
  if (!token) return config;
  return { ...config, headers: { ...(config.headers || {}), Authorization: `Bearer ${token}` } };
}
